import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Card } from 'ni-ui/layout';
import { shape } from 'prop-types';
import Text, { TextTypes } from 'ni-ui/text';
import Button, { ButtonTypes } from 'ni-ui/button';
import styles from './styles.scss';
import { messageReceiver } from './Helpers';
import { AppContext } from '../../app-context';
import { TAFAuthentications } from '../../api';
import Fallback from '../fallback';


// Center the pop-up on the screen
const width = 550;
const height = 700;
const left = (window.screen.width - width) / 2;
const top = (window.screen.height - height) / 2;

const TAF = ({ TAFData }) => {
  const { 
    setContextState,
    outletRef,
    orderRef,
    orderDetails,
    currentSplitPaymentCard,
    refetchOrder
   } = useContext(AppContext);
   const { isSplitPayment, _embedded } = orderDetails.order;
  const {
    uri
  } = TAFData.authenticationMethod.uriData;
  const authenticateUiURL = `${uri}?origin=${window.location.origin}`
  const urlData = new URL(authenticateUiURL);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const getPaymentRef = () => {
    if (isSplitPayment) return _embedded.payment[currentSplitPaymentCard]?.reference
    return orderDetails.order.paymentReference
  }
  const handleTAFFlow = useCallback( async(TAFResponse) => {
    try {
      const { data } = await TAFAuthentications(outletRef, orderRef, getPaymentRef(), TAFResponse);
      if (data.state) {
        refetchOrder()
      }
    } catch (error) {
      setContextState({
        orderDetails: {
          ...orderDetails,
          state: 'FAILED',
        }
      });
    }
  }, [currentSplitPaymentCard]) 
  
  
  useEffect(() => {
    if (isConfirmed) {
      const windowRef =  window.open(
        authenticateUiURL,
        'AuthenticatorWindow',
        `width=${width},height=${height},top=${top},left=${left},resizable=no,scrollbars=no`
      ); 
      const handleMessage = event =>
        messageReceiver(event, windowRef, urlData, TAFData, handleTAFFlow);
    
      window.addEventListener('message', handleMessage);
    
      return () => {
        window.removeEventListener('message', handleMessage);
      };
    }
  }, [isConfirmed]);

  if (!isConfirmed) {
    return( <Card inheritBackgroundColor>
      <div data-testid="taf_confirm_message" className={`${styles.TAF} ${styles.flexColumn} ${styles.inheritWidth}`}>
        <div className={`${styles.flexColumn}`} style={{ marginBottom: '25px'}}>
          <Text textKey="TAF_CONTINUE_HADING" type={TextTypes.H3}  />
          <Text textKey="TAF_CONFIRMATION_MESSAGE" type={TextTypes.BODY}/>
        </div>
        <Button
          type={ButtonTypes.PRIMARY}
          onClick={() => setIsConfirmed(true)}
          >
          <Text textKey="CONTINUE" textColor="white"/>
        </Button>
      </div>
    </Card>)
  }
  return (
    <Card inheritBackgroundColor>
      <div data-testid="TAF_message" className={`${styles.TAF} ${styles.inheritWidth}`}>
        <Fallback message="CUSTOM_PENDING_PAYMENT_MESSAGE"/>
      </div>
    </Card>);
};

TAF.propTypes = {
  TAFData: shape({}),
};

TAF.defaultProps = {
  TAFData: null,
};

export default React.memo(TAF);
